// App version - increment this when you need to force cache clear for all users
export const APP_VERSION = "2.1.0";

// Check and migrate if needed
export function checkVersion() {
  try {
    const storedVersion = localStorage.getItem("appVersion");

    if (storedVersion !== APP_VERSION) {
      console.log(
        `App version updated from ${storedVersion} to ${APP_VERSION}`,
      );

      // Clear all cache except location (user preference)
      const keysToRemove = ["prayerTimings", "lastFetchDate"];
      keysToRemove.forEach((key) => localStorage.removeItem(key));

      // Clear location cache - we added 'source' field to location structure
      localStorage.removeItem("cachedLocation");

      // Update stored version
      localStorage.setItem("appVersion", APP_VERSION);

      console.log("Cache cleared for new version");
      return true;
    }

    return false;
  } catch (error) {
    console.error("localStorage not available:", error);
    return false;
  }
}

// Force clear all cache (useful for major updates)
export function forceClearAllCache() {
  try {
    console.log("Force clearing all cache...");
    localStorage.clear();
    localStorage.setItem("appVersion", APP_VERSION);
    console.log("All cache cleared");
  } catch (error) {
    console.error("Failed to clear cache:", error);
  }
}
